import axios from "../axios"
import apiUrls from "../urls"


export default {
    fetchAdditionalData (data) {
        return axios.post(apiUrls.getAdditional, data);
  },
    updateAdditionalData (data) {
      return axios.post(apiUrls.updateAdditional, data);
  },
  offerProcessing(data){
    return axios.post(apiUrls.offerProcessing, data);
  },
  sendDataCollection(data){
    return axios.post(apiUrls.sendDataCollection, data);
  },
    submitAdditionalData (data) {
        return axios.post(apiUrls.submitAdditional, data);
    },
    createAdditionalTest (data) {
        return axios.post(apiUrls.createAdditional, data)
    },
}
